import script from "./CvView.vue?vue&type=script&setup=true&lang=js"
export * from "./CvView.vue?vue&type=script&setup=true&lang=js"

import "./CvView.vue?vue&type=style&index=0&id=639dd1a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639dd1a5"]])

export default __exports__